<script lang="ts">
  import { dataStore } from "@stores/datastore";

  const isEmpty = dataStore.selectionHistoryIsEmpty();
  const backLength = dataStore.selectionHistoryLength();

  const goBack = () => {
    const selectable = dataStore.selectionHistoryGoBackward();
    if (!selectable) {
      dataStore.unSelect();
      return;
    }

    if ("source" in selectable && "target" in selectable) {
      dataStore.setSelectedEdge(selectable);
    }

    if ("name" in selectable) {
      dataStore.setSelectedNode(selectable);
    }
  }
</script>

<button
  disabled={$isEmpty}
  on:click={goBack}
  class="normal-case btn btn-sm rounded-xl"
>
  back ({$backLength})
</button>
